<form [formGroup]="addressForm">
    <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
        <div>
            <label
                for="fullName"
                class="block text-sm font-medium text-gray-700"
            >
                Full name
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    formControlName="fullName"
                    autoComplete="name"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                />
            </div>
        </div>

        <div class="sm:col-span-2" *ngIf="!hideCompany">
            <label
                for="company"
                class="block text-sm font-medium text-gray-700"
            >
                Company
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="company"
                    id="company"
                    formControlName="company"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div class="sm:col-span-2">
            <label
                for="streetLine1"
                class="block text-sm font-medium text-gray-700"
            >
                Address
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="streetLine1"
                    id="streetLine1"
                    formControlName="streetLine1"
                    autoComplete="street-address"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                    [class.border-red-500]="addressForm.get('streetLine1')?.invalid && addressForm.get('streetLine1')?.touched"
                />
            </div>
            <p *ngIf="addressForm.get('streetLine1')?.invalid && addressForm.get('streetLine1')?.touched" class="mt-1 text-xs text-red-600">Address is required</p>
        </div>

        <div class="sm:col-span-2">
            <label
                for="streetLine2"
                class="block text-sm font-medium text-gray-700"
            >
                Apartment, suite, etc.
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="streetLine2"
                    id="streetLine2"
                    formControlName="streetLine2"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div>
            <label
                for="city"
                class="block text-sm font-medium text-gray-700"
            >
                City
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="city"
                    id="city"
                    autoComplete="address-level2"
                    formControlName="city"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                    [class.border-red-500]="addressForm.get('city')?.invalid && addressForm.get('city')?.touched"
                />
            </div>
            <p *ngIf="addressForm.get('city')?.invalid && addressForm.get('city')?.touched" class="mt-1 text-xs text-red-600">City is required</p>
        </div>

        <div>
            <label
                for="countryCode"
                class="block text-sm font-medium text-gray-700"
            >
                Country
            </label>
            <div class="mt-1">
                <select
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    formControlName="countryCode"
                    id="countryCode"
                    [class.border-red-500]="addressForm.get('countryCode')?.invalid && addressForm.get('countryCode')?.touched"
                >
                    <option value="" disabled>Select country</option>
                    <option *ngFor="let country of availableCountries" [ngValue]="country.code">
                        {{ country.name }}
                    </option>
                </select>
            </div>
            <p *ngIf="addressForm.get('countryCode')?.invalid && addressForm.get('countryCode')?.touched" class="mt-1 text-xs text-red-600">Country is required</p>
        </div>

        <div>
            <label
                for="province"
                class="block text-sm font-medium text-gray-700"
            >
                State / Province
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="province"
                    id="province"
                    formControlName="province"
                    autoComplete="address-level1"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div>
            <label
                for="postalCode"
                class="block text-sm font-medium text-gray-700"
            >
                Postal code
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="postalCode"
                    id="postalCode"
                    formControlName="postalCode"
                    autoComplete="postal-code"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                    [class.border-red-500]="addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched"
                />
            </div>
            <p *ngIf="addressForm.get('postalCode')?.invalid && addressForm.get('postalCode')?.touched" class="mt-1 text-xs text-red-600">Postal code is required</p>
        </div>

        <div class="sm:col-span-2">
            <label
                for="phoneNumber"
                class="block text-sm font-medium text-gray-700"
            >
                Phone
            </label>
            <div class="mt-1">
                <input
                    type="text"
                    name="phoneNumber"
                    id="phoneNumber"
                    formControlName="phoneNumber"
                    autoComplete="tel"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>
    </div>
</form>
